import * as z from "zod";

export const participantSchema = z.object({
  id: z.uuid(),
  full_name: z.string(),
  speaker_id: z.string(),
  created_at: z.iso.datetime(),
});

export const basicMetadataSchema = z.object({
  bot_external_id: z.string(),
});

export const utteranceEventMetadataSchema = basicMetadataSchema.extend({
  bot_id: z.uuid(),
  bot_start_datetimetz: z.iso.datetime(),
  bot_state: z.string(),
  bot_state_group: z.enum([
    "SCHEDULED",
    "PREPARATION",
    "ACTIVE",
    "ENDED",
    "ERROR",
    "POST_PROCESSING",
  ]),
  bot_utterance_id: z.uuid(),
  bot_utterance_start_datetimetz: z.iso.datetime(),
  bot_utterance_duration_ms: z.number(),
});
